<template>
  <section class="p-1">
    <OverlayPageVue :showOverlay="loader" />
    <div class="mt-6">
      <v-card flat>
        <v-card-title class="d-flex justify-space-between p-0 m-0">
          <div class="ps-2 headingFontsize">Jobs</div>
          <div>
            <bread-crumb :bread-crumbs="['Jobs']" />
          </div>
        </v-card-title>
        <v-divider class="p-0 m-0 primary--text"></v-divider>
        <v-card-text>
          <v-row>
            <v-col> <Transactionjobs /> </v-col>
            <v-col> <Customerjobs @showOverlay="showOverlay" /> </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </div>
  </section>
</template>
<script>
import OverlayPageVue from "../../../utils/OverlayPage.vue";
import Customerjobs from "./Customerjobs.vue";
import Transactionjobs from "./Transactionjobs.vue";
import BreadCrumb from "@/components/navigations/BreadCrumb.vue";
export default {
  name: "Jobs",
  data: () => ({
    loader: false,
  }),

  props: {},
  components: {
    BreadCrumb,
    Customerjobs,
    Transactionjobs,
    OverlayPageVue,
  },
  methods: {
    showOverlay(val) {
      this.loader = val;
    },
  },
};
</script>
<style>
.v-expansion-panel {
  width: 500px !important;
}
</style>
